import judahTheme from 'typography-theme-judah'

import { TypographyOptions } from './types'

export const typography: TypographyOptions = {
  ...judahTheme,
  baseFontSize: '16px',
}
